import * as React from 'react';

export function SvgMicrosoftTeamsTile({
  hideBorder,
  ...props
}: {
  hideBorder?: boolean;
  [key: string]: any;
}) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="64" height="64" rx="12" fill="white" />
      {!hideBorder && (
        <rect
          x="0.5"
          y="0.5"
          width="63"
          height="63"
          rx="11.5"
          stroke="#0B1228"
          strokeOpacity="0.14"
        />
      )}
      <path
        d="M38.5836 28.124H47.1937C48.0072 28.124 48.6666 28.7834 48.6666 29.5969V37.4395C48.6666 40.4291 46.243 42.8527 43.2534 42.8527H43.2278C40.2382 42.8531 37.8143 40.4299 37.8139 37.4403V28.8938C37.8139 28.4686 38.1585 28.124 38.5836 28.124Z"
        fill="#5059C9"
      />
      <path
        d="M44.403 26.5736C46.3296 26.5736 47.8914 25.0118 47.8914 23.0852C47.8914 21.1587 46.3296 19.5969 44.403 19.5969C42.4764 19.5969 40.9147 21.1587 40.9147 23.0852C40.9147 25.0118 42.4764 26.5736 44.403 26.5736Z"
        fill="#5059C9"
      />
      <path
        d="M33.5503 26.5736C36.3331 26.5736 38.5891 24.3177 38.5891 21.5349C38.5891 18.752 36.3331 16.4961 33.5503 16.4961C30.7675 16.4961 28.5115 18.752 28.5115 21.5349C28.5115 24.3177 30.7675 26.5736 33.5503 26.5736Z"
        fill="#7B83EB"
      />
      <path
        d="M40.2689 28.124H26.0565C25.2527 28.1439 24.6169 28.8109 24.6356 29.6147V38.5597C24.5233 43.3831 28.3394 47.3858 33.1627 47.5039C37.986 47.3858 41.8021 43.3831 41.6899 38.5597V29.6147C41.7085 28.8109 41.0727 28.1439 40.2689 28.124Z"
        fill="#7B83EB"
      />
      <path
        d="M33.9379 28.124V40.6589C33.934 41.2337 33.5857 41.7501 33.0542 41.969C32.8849 42.0406 32.7031 42.0774 32.5193 42.0775H25.3177C25.217 41.8217 25.124 41.5659 25.0464 41.3023C24.7751 40.4128 24.6366 39.4897 24.6356 38.5597L24.6356 29.6124C24.6169 28.8099 25.2517 28.1439 26.0542 28.124H33.9379Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M33.1627 28.124V41.4341C33.1627 41.6178 33.1258 41.7997 33.0542 41.969C32.8353 42.5005 32.3189 42.8488 31.7441 42.8527H25.6821C25.5503 42.5969 25.4263 42.3411 25.3177 42.0775C25.2092 41.8139 25.124 41.5659 25.0464 41.3023C24.7751 40.4128 24.6366 39.4897 24.6356 38.5597L24.6356 29.6124C24.6169 28.8099 25.2517 28.1439 26.0542 28.124H33.1627Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M33.1627 28.124V39.8837C33.1568 40.6647 32.5251 41.2964 31.7441 41.3023L25.0464 41.3023C24.7751 40.4128 24.6366 39.4897 24.6356 38.5597L24.6356 29.6124C24.6169 28.8099 25.2517 28.1439 26.0542 28.124H33.1627Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M32.3875 28.124V39.8837C32.3816 40.6647 31.7499 41.2964 30.9689 41.3023L25.0464 41.3023C24.7751 40.4128 24.6366 39.4897 24.6356 38.5597L24.6356 29.6124C24.6169 28.8099 25.2517 28.1439 26.0542 28.124H32.3875Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M33.9379 24.1163V26.5581C33.8061 26.5659 33.6821 26.5736 33.5503 26.5736C33.4185 26.5736 33.2945 26.5659 33.1627 26.5581C32.901 26.5408 32.6415 26.4992 32.3875 26.4341C30.8177 26.0623 29.5209 24.9614 28.8991 23.4729C28.7922 23.2229 28.7091 22.9633 28.6511 22.6977H32.5193C33.3015 22.7006 33.9349 23.334 33.9379 24.1163Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M33.1627 24.8914L33.1627 26.5581C32.901 26.5408 32.6415 26.4992 32.3875 26.4341C30.8177 26.0623 29.5209 24.9614 28.8991 23.4729H31.7441C32.5263 23.4758 33.1597 24.1092 33.1627 24.8914Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M33.1627 24.8914L33.1627 26.5581C32.901 26.5408 32.6415 26.4992 32.3875 26.4341C30.8177 26.0623 29.5209 24.9614 28.8991 23.4729H31.7441C32.5263 23.4758 33.1597 24.1092 33.1627 24.8914Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M32.3875 24.8914V26.4341C30.8177 26.0623 29.5209 24.9614 28.8991 23.4729L30.9689 23.4728C31.7512 23.4758 32.3845 24.1092 32.3875 24.8914Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        d="M16.7542 23.4728H30.9666C31.7513 23.4728 32.3875 24.109 32.3875 24.8938V39.1062C32.3875 39.8909 31.7513 40.5271 30.9666 40.5271H16.7542C15.9694 40.5271 15.3333 39.8909 15.3333 39.1062V24.8938C15.3333 24.109 15.9694 23.4728 16.7542 23.4728Z"
        fill="url(#paint0_linear_767_15238)"
      />
      <path
        d="M27.5999 28.8821H24.7588V36.6186H22.9488V28.8821H20.1209V27.3814H27.5999V28.8821Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_767_15238"
          x1="21.1239"
          y1="14.4774"
          x2="40.6025"
          y2="50.7437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A62C3" />
          <stop offset="0.5" stopColor="#4D55BD" />
          <stop offset="1" stopColor="#3940AB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
